import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';


export class LH_DecantAddLocation extends Component {
    static displayName = LH_DecantAddLocation.name;

    constructor(props) {
        super(props);
        this.history = props.history;
        this.state = {
            loading: false,
            alertMessage: "",
            arrayLocation: "",
            selectedContainerRef: "",
            scannedSSCC: ""
        }
    }

    componentDidMount() {
        if (this.props.location && this.props.location.state) {
            this.setState({
                selectedContainerRef: this.props.location.state.selectedContainerRef,
                scannedSSCC: this.props.location.state.scannedSSCC
            });
            this.refs.arrayLocationInput.focus();

        }
    }
    goto(page) {
        this.history.push({
            pathname: page,
            state: this.state
        });
    }

    decantAddArrayLocation() {
        this.setState({ alertMessage: "" });

        if (!this.state.selectedContainerRef || this.state.selectedContainerRef == "" || !this.state.scannedSSCC || this.state.scannedSSCC == "") {
            this.setState({ alertMessage : "Container Number and SSCC cannot be loaded" });
            return;
        }
        if (!this.state.arrayLocation || this.state.arrayLocation == "") {
            this.setState({ alertMessage: "Please enter a valid location" });
            this.refs.arrayLocationInput.focus();
            return;
        }

        this.state.arrayLocation = this.state.arrayLocation.trim();
        var barCodeFormat = this.state.arrayLocation.split("-");
        if (!barCodeFormat || barCodeFormat.length !== 4) {
            this.setState({ loading: false, arrayLocation: "", alertMessage: "Invalid Location!! Location should be of this format : Stage-01-01-09" });
            this.refs.arrayLocationInput.focus();
            return;
        }
        fetch(`api/LinenhouseXdoc/DecantAddArrayLocation?containerRef=${this.state.selectedContainerRef}&sscc=${this.state.scannedSSCC}&location=${this.state.arrayLocation}`)
            .then(async response => {

                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ alertMessage: errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;

                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success)
                        {
                            this.goto('../LinenhouseXdoc/LH_DecantBuildArray');
                        }
                        else {
                            //TODO: Check with Bruce about the wording of this message
                            this.setState({ alertMessage: "Failed to add Array Location!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to add Array Location!!" });
                    }
                }

            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }
    render() {

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        const handleArrayLocationInputKeyPress = e => {
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.decantAddArrayLocation();
            }
        };
        return (
            <div>
                <Container>
                    <Row className="mb-3">
                        <Col xs={9}><h4>Decant Add Location</h4></Col>
                        <Col xs={3}><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('../LinenhouseXdoc/LH_LoadOpenASN'); }} >
                            Back
                        </button></Col>
                    </Row>
                    <Row>
                        <Col>{alertMessage}</Col>
                    </Row>
                    <Row className="mb-3" >
                        <Col xs={9}><h5><label>The SSCC you have scanned does not have a location in the put array</label></h5></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}><label className="font-weight-bold" >Please scan new location for array:</label></Col>
                        <Col xs={7}><input ref="arrayLocationInput" className="form-control" placeholder="Stage-1-1-1" value={this.state.arrayLocation}
                            onChange={(e) => {
                                this.setState({ arrayLocation: e.target.value });
                            }} onKeyPress={handleArrayLocationInputKeyPress} readOnly={this.state.loading} >
                        </input></Col>
                    </Row>
                </Container>
            </div>
        );
    }


}
